import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDeleteFiles } from 'api/services/file';

export const deleteFileAction = createAsyncThunk('deleteFile/fetchDeleteFile', async (id: number) => {
    const result = await fetchDeleteFiles(id);
    return { ...result, id };
});
